import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TelegramIcon from 'mdi-react/TelegramIcon';

import { IconButton } from '@crm-framework/icon-button';
import { Permissions } from '@crm-framework/auth';
import { ReduxInject } from '@crm-framework/saga-injector';

import { USER_RIGHTS } from '@crm-package/auth';

import {
  chatActions,
  chatReducer,
  getAvailableLeadsSelector,
  STORE_PREFIX,
} from './store';
import { watchChatSagas } from './saga';

export const LeadChatButton: React.FC<{ leadId: number }> = ({ leadId }) => {
  const dispatch = useDispatch();
  const leadsWithAvailableChats = useSelector(getAvailableLeadsSelector);

  useEffect(() => {
    dispatch(chatActions.checkLeadChatButtonEnable(leadId));
  }, []);

  const changeIsOpenChat = useCallback(() => {
    dispatch(chatActions.searchChat(leadId));
  }, []);

  return leadsWithAvailableChats?.includes(leadId) ? (
    <IconButton
      icon={TelegramIcon}
      appearance="primary"
      onClick={changeIsOpenChat}
      className="lead-chat__button"
    />
  ) : (
    <></>
  );
};

export const LeadChatButtonInject: React.VFC<{ leadId: number }> = ({
  leadId,
}) => (
  <Permissions
    viewRights={[
      USER_RIGHTS.XCHAT_ALLOW_TO_CHAT_ALL,
      USER_RIGHTS.XCHAT_ALLOW_TO_CHAT_ASSIGNED,
    ]}
    isAccessAllowedByOneOfRight
    FallbackComponent={null}>
    <ReduxInject
      reducerKey="chat"
      keyName={STORE_PREFIX}
      reducer={chatReducer}
      saga={watchChatSagas}>
      <LeadChatButton leadId={leadId} />
    </ReduxInject>
  </Permissions>
);
